import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/g6-180.png";
import type { Product } from "../../types";
import { domeTurret as productListDomeTurret } from "../product-list-groups/domeTurret";
import { deployment, outdoorReady } from "../properties";

export const g6180: Product = {
  id: "g6180",
  productTitle: "G6 180",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-g6-180`],
  storePathParts: {
    productSlug: "uvc-g6-180",
    category: "cameras-dome-turret",
  },
  description: "g6180.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '136 x 64 x 92 mm\n(5.6 x 2.5 x 3.6")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "Dual 4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: 'Dual 1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g6180.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g6180.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.twoWayAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
